import FsLightbox from 'fslightbox-react';
import Image from '@jetshop/ui/Image';
import { styled } from 'linaria/react';
import React, { useState } from 'react';
import { theme } from '../../Theme';

const OuterWrapper = styled('div')`
  .fslightbox-slide-btn-next-container {
    padding-right: 4px;
    .fslightbox-slide-btn {
      border-radius: 15px 0 0 15px;
    }
  }
  .fslightbox-slide-btn-previous-container {
    padding-left: 0px;
    .fslightbox-slide-btn {
      border-radius: 0 15px 15px 0;
    }
    .fslightbox-slide-btn:after {
      transform: rotate(180deg);
    }
  }

  .fslightbox-slide-btn {
    height: 29px;
    width: 40px;
    background: ${theme.colors.red};
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      display: none;
    }
    &:after {
      content: '';
      height: 14px;
      width: 10px;
      background-image: url(../../../svg/ChevronRight.svg);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  }
`;
const ImageGridWrapper = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  position: relative;

  &.one-image {
    grid-template-columns: 1fr;
    max-width: 650px;
    margin: auto;
  }

  .image {
    background: ${theme.colors.lightgrey};

    > div {
      mix-blend-mode: darken;
    }
  }

  > * {
    cursor: zoom-in;
  }
`;

const VideoWrapper = styled('div')`
  position: relative;
  /* padding-bottom: 56.25%;  */
  padding-bottom: 100%;
  padding-top: 0;
  height: 0;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export default function ImageGrid({ product }) {
  const [toggler, setToggler] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const video = product?.customFields?.filter(
    customField => customField.key === 'video'
  );

  let imageArray = [...product?.images];
  let sources = [];
  for (let i = 0; i < imageArray.length; i++) {
    sources.push(imageArray[i].url);
  }
  if (video?.length > 0) {
    var videoId = video?.length > 0 && video[0].stringValue?.split('.com/')[1];
    var correctVideoUrl =
      'https://player.vimeo.com/video/' +
      videoId +
      '?background=1&autoplay=1&loop=1&color=ffffff';
    var videoObject = { video: true, videoUrl: correctVideoUrl };
    imageArray.splice(1, 0, videoObject);
    sources.splice(
      1,
      0,
      <iframe
        title="Video"
        width="1000"
        height="1000"
        src={correctVideoUrl}
        frameBorder="0"
        allow="accelerometer; autoplay; fullscreen; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    );
  }

  return (
    <OuterWrapper>
      <ImageGridWrapper
        className={
          imageArray?.length === 1 && video?.length === 0 ? 'one-image' : ''
        }
      >
        {imageArray.map((image, index) => {
          if (image.video) {
            return (
              <div className="image">
                <VideoWrapper>
                  <iframe
                    title="Video"
                    width="1000"
                    height="1000"
                    src={correctVideoUrl}
                    frameBorder="0"
                    allow="accelerometer; autoplay; fullscreen; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </VideoWrapper>
              </div>
            );
          } else {
            return (
              <div className="image">
                <Image
                  critical
                  key={index}
                  src={image.url}
                  alt={image.alt}
                  modifiedDate={image?.modifiedDate}
                  aspect="1:1"
                  sizes={800}
                  cover={false}
                  onClick={() => {
                    setImageIndex(index);
                    setToggler(!toggler);
                  }}
                />
              </div>
            );
          }
        })}
      </ImageGridWrapper>
      <FsLightbox
        toggler={toggler}
        type="image"
        sources={sources}
        sourceIndex={imageIndex}
      />
    </OuterWrapper>
  );
}
